import { CircularProgress } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useIntl } from "react-intl";
import { DetailElementType } from "types/common-types";

const RowElement = (
  titleKey: string,
  content: string | number | Date,
  isLoading?: boolean,
  customContent?: JSX.Element,
  useInternazionalization: boolean = true
) => {
  const { formatMessage: t } = useIntl();
  if (content instanceof Date) {
    content = format(content, "P");
  }

  return {
    title: useInternazionalization ? t({ id: titleKey }) : titleKey,
    component: (
      <>
        {isLoading ? (
          <CircularProgress style={{ float: "left" }} size={16} />
        ) : !customContent || !content ? (
          <span style={{ float: "left" }}>{content ?? "-"}</span>
        ) : (
          customContent
        )}
      </>
    ),
    type: DetailElementType.Row,
  };
};

export default RowElement;
